(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.scrollReady) return;
    const grid = root.querySelector('.collection-grid');
    const more = root.querySelector('[data-collection-next]');
    const status = root.querySelector('[data-collection-status]');
    if (!grid || !more) return;
    root.dataset.scrollReady = 'true';
    let busy = false, failed = false;
    const seen = new Set([...grid.children].map(card => card.dataset.productId));
    const pages = new Set();
    async function load() {
      if (busy || !more.getAttribute('href')) return;
      const url = new URL(more.href, location.href);
      if (url.origin !== location.origin || pages.has(url.href)) return;
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const pageKey = url.href;
      url.searchParams.set('section_id', root.dataset.sectionId);
      busy = true;
      status.textContent = 'Loading more designs…';
      grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, {signal: AbortSignal.timeout(20000)});
        if (!response.ok) throw Error('Page unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextRoot = [...doc.querySelectorAll('[data-collection-scroll]')].find(el => el.dataset.sectionId === root.dataset.sectionId);
        const nextGrid = nextRoot?.querySelector('.collection-grid');
        if (!nextGrid || !nextGrid.children.length) throw Error('No product grid');
        const fragment = document.createDocumentFragment();
        for (const card of [...nextGrid.children]) {
          if (!seen.has(card.dataset.productId)) {
            seen.add(card.dataset.productId);
            fragment.append(card);
          }
        }
        grid.append(fragment);
        pages.add(pageKey);
        failed = false;
        const next = nextRoot.querySelector('[data-collection-next]')?.getAttribute('href');
        if (next) more.setAttribute('href', next);
        else { more.removeAttribute('href'); more.hidden = true; observer?.disconnect(); }
        status.textContent = next ? '' : 'All designs loaded';
      } catch {
        failed = true;
        status.textContent = 'Couldn’t load more designs. Select Load more to retry.';
      } finally {
        busy = false;
        grid.removeAttribute('aria-busy');
        if (!failed && more.getAttribute('href') && more.getBoundingClientRect().top < innerHeight + 600) load();
      }
    }
    more.addEventListener('click', event => { event.preventDefault(); failed = false; load(); });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      if (entries.some(e => e.isIntersecting) && !failed) load();
    }, {rootMargin: '600px'}) : null;
    observer?.observe(more);
  }
  const start = () => document.querySelectorAll('[data-collection-scroll]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();


  } catch(e) { console.error(e); }
})();
})();
